module.exports = __webpack_public_path__ + "img/star.7f0ef3dd.png";